import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=38a584ef&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=38a584ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a584ef",
  null
  
)

export default component.exports